import { useLayoutEffect, useState } from "react";
import type { RefObject } from "react";

export function useFireflyTabAnchorScreen(
  tabRef: RefObject<HTMLElement | null>,
  localAnchorX: number,
  localAnchorY: number,
  deps: readonly unknown[],
): { x: number; y: number } {
  const [screen, setScreen] = useState({ x: 0, y: 0 });

  useLayoutEffect(() => {
    const update = () => {
      const el = tabRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      setScreen({
        x: rect.left + localAnchorX,
        y: rect.top + localAnchorY,
      });
    };
    update();
    window.addEventListener("resize", update);
    window.addEventListener("scroll", update, { passive: true });
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("scroll", update);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- caller supplies motion deps
  }, [tabRef, localAnchorX, localAnchorY, ...deps]);

  return screen;
}
